import './App.css';

import {
   BrowserRouter, Route, Routes
} from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Home from './views/Home/Home';
import AuthLayout from './layout/AuthLayout';
import Login from './views/Login/Login';
import Register from './views/Register/Register';
import ResetPassword from './views/ResetPassword/ResetPassword';
import Thankyou from './views/Thankyou/Thankyou';
import Privacy from './views/Privacy/Privacy';
import CMSLayout from './layout/CMSLayout';
import Terms from './views/Terms/Terms';
import PageNotFound from './views/PageNotFound/PageNotFound';
import { queryClient } from './config';
import { QueryClientProvider } from "react-query";
import { WagmiConfig } from "wagmi";
import { wagmiConfig } from './lib/wagmi';
import { Toaster } from 'react-hot-toast';
import { ModalContextProvider } from './contexts/ModalContext';
import InnerPagesLayout from './layout/InnerPagesLayout';
import Dashboard from './views/Dashboard/Dashboard';
import Transaction from './views/Transaction/Transaction';
import Withdraw from './views/Withdraw/Withdraw';
import Myprofile from './views/Myprofile/Myprofile';
import Activity from './views/Activity/Activity';
import HowToBuy from './views/HowToBuy/HowToBuy';
import BuyToken from './views/BuyToken/BuyToken';
import MyToken from './views/MyToken/MyToken';
import ForgotPassword from './views/ResetPassword/ForgotPassword';
import DisableDevtool from 'disable-devtool';
import Otp from './views/OTP/Otp';
import HowItWorks from './views/Home/HowItWorks';
import Whitepaper from './views/Whitepaper/Whitepaper';
import { useEffect } from 'react';



const App = (props) => {

   DisableDevtool()


   async function checkVersionAndReloadIfNeeded() {
      try {
         const response = await fetch('/meta.json', { cache: 'no-cache' });
         const data = await response.json();
         const currentVersion = data.version;
         let localVersion = localStorage.getItem('app_version');
         if (!localVersion) {
            localStorage.setItem('app_version', currentVersion);
            localVersion = currentVersion;
         }
         if (localVersion && localVersion !== currentVersion) {
            localStorage.setItem('app_version', currentVersion);
            window.location.reload(true);
         }
      }
      catch (err) {
         console.log("Error fetching version:", err);
      }
   }

   useEffect(() => {

      checkVersionAndReloadIfNeeded();
      const onVisibilityChange = () => {
         if (document.visibilityState === 'visible') {
            checkVersionAndReloadIfNeeded();
         }
      };

      document.addEventListener('visibilitychange', onVisibilityChange);

      // Cleanup
      return () => {
         document.removeEventListener('visibilitychange', onVisibilityChange);
      };


   }, []);

   return (
     <WagmiConfig config ={wagmiConfig}>
       <QueryClientProvider client={queryClient}>
         <BrowserRouter>
            <ModalContextProvider>
            <Routes>

               <Route element={<MainLayout />}>
                  <Route path='/' element={<Home />} />
               </Route>
               <Route element={<AuthLayout />}>
                  <Route path='/login' element={<Login />} />
                  <Route path='/register' element={<Register />} />
                  <Route path='/register/:id' element={<Register />} />
                  <Route path='/resetpassword' element={<ResetPassword />} />
                  <Route path='/forgotpassword/:id' element={<ForgotPassword />} />
                  <Route path='/otp' element={<Otp />} />
                  <Route path='/thankyou/:id' element={<Thankyou />} />
               </Route>
               <Route element={<CMSLayout />}>
                  <Route path='/privacy' element={<Privacy />} />
                  <Route path='/terms' element={<Terms />} />
                  <Route path='/keynotes' element={<HowItWorks />} />
                  <Route path='/whitepaper' element={<Whitepaper />} />
               </Route>
               <Route element={<InnerPagesLayout />}>
                  <Route path='/dashboard' element={<Dashboard />} />
                  <Route path='/transaction' element={<Transaction />} />
                  <Route path='/withdraw' element={<Withdraw />} />
                  <Route path='/myprofile' element={<Myprofile />} />
                  <Route path='/activity' element={<Activity />} />
                  <Route path='/howtobuy' element={<HowToBuy />} />
                  <Route path='/buytoken' element={<BuyToken />} />
                  <Route path='/mytoken' element={<MyToken />} />
               </Route>
               <Route path='*' element={<PageNotFound />} />
            </Routes>
            </ModalContextProvider>
         </BrowserRouter>
         <Toaster position='top-center' />

      </QueryClientProvider>
     </WagmiConfig>
   );
}

export default App;
